import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useCallback, useState } from "react";

import { AjaxResult } from "../../../enums/ajaxResult";
import { FormSection } from "../../shared/formSection";
import { FormField } from "../../shared/formField";
import { TextField } from "../../shared/TextField";
import { useApi } from "../../useApi";

interface Props {
    dealerId: number | undefined;
    onClose: () => void;
    onLoadOrgs: () => void;
}

export function AddOrganizationDialog({ dealerId, onLoadOrgs, onClose }: Props) {
    const { orgApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [newOrganization, setNewOrganization] = useState<{ name: string; }>({
        name: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChangeName = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();
        setNewOrganization(prev => ({ ...prev, name: e.target.value }));
    }, []);

    const handleSave = useCallback(() => {
        setLoading(true);
        orgApi.postOne({ id: 0, ...newOrganization, dealerId }).then((r) => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar(
                    `Successfully created new organization: "${newOrganization.name}"`,
                    { variant: "success" },
                );
                onLoadOrgs();
                onClose();
            } else {
                enqueueSnackbar(
                    `Failed to create new organization: "${newOrganization.name}"`,
                    { variant: "error" },
                );
            }
            setLoading(false);
        });
    }, [orgApi, newOrganization, dealerId, enqueueSnackbar, onLoadOrgs, onClose]);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
        >
            <DialogContent>
                <FormSection headerText="Create New Organization">
                    <FormField label="Organization Name" required>
                        <TextField
                            placeholder="Organization Name"
                            value={newOrganization.name}
                            onChange={handleChangeName}
                            variant="outlined"
                            stylesProps={{ width: 300 }}
                        />
                    </FormField>
                </FormSection>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={loading || newOrganization.name === ""}
                >
                    {loading ? "Creating..." : "Create"}
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );
}